const Progress: ng.IComponentOptions = {
    template: require('./progress.html'),
    bindings: {
        account: '<',
    },
};

export default angular.module('mpdx.coaches.progress.component', []).component('coacheeProgress', Progress).name;
